import { FC, PropsWithChildren, ReactEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import { Button as MaterialButton } from '@mui/material';

import messages from './messages';

import useStyles from './styles';

type Props = {
  onClick: ReactEventHandler;
};

const FiltersButton: FC<PropsWithChildren<Props>> = ({ onClick, children }) => {
  const { classes } = useStyles();
  return (
    <MaterialButton
      startIcon={<FilterListRoundedIcon />}
      classes={{
        root: classes.root,
      }}
      onClick={onClick}
    >
      <FormattedMessage {...messages.button} />
      {children}
    </MaterialButton>
  );
};

export default FiltersButton;
